import { Box, Typography } from "@mui/material";
import DataContent from "../../../components/DataContent";
import { DataCodeEnum } from "../../../constants/enum";

const MeaningOfAngelNumbers = () => {
  return (
    <Box m={2}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          color="primary"
          variant="h5"
          sx={{
            fontWeight: "bold",
          }}
          gutterBottom
        >
          What are angel numbers?
        </Typography>
      </Box>
      <DataContent
        code={DataCodeEnum.WHAT_ARE_ANGEL_NUMBERS}
        name="What are angel numbers?"
        fields={[
          {
            code: "name",
            name: "Name",
          },
          {
            code: "description",
            name: "Description",
          },
        ]}
      />
    </Box>
  );
};

export default MeaningOfAngelNumbers;
